import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { RequestResponse } from 'src/app/shared/models/request-response.interface'
import { Observable, throwError } from 'rxjs'


@Injectable({
    providedIn: 'root'
})

export class DiasLibresService {
    constructor(
        private http: HttpClient,
        private alert: AlertHelper,
    ) { }
    //ESTO NO PERTENECE AQUÍ, PERO SI SE COMENTA O SE QUITA, SE CAE EL SISTEMA ASDA XD
    TraerTrabajadores(): Observable<RequestResponse> {
      return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/trabajador/`)
      .pipe(
        map((res: RequestResponse) =>{
          return res;
        }),
        catchError((err)=> this.handlerError(err))
      );
    }
    //Eliminar
    eliminarDiasLibre(id:number): Observable<RequestResponse> {
      return this.http
      .delete<RequestResponse >(`${environment.API}/rrhh/diasLibres/eliminar/${id}`)
      .pipe(
        map((res:RequestResponse) =>{
          return res;
        }),
        catchError((err)=> this.handlerError(err))
      );
    }
    //crear
    crearDiaLibre(diasLibres:any): Observable<RequestResponse> {
      return this.http
      .post<RequestResponse>(`${environment.API}/rrhh/diasLibres/crear`,diasLibres)
      .pipe(
        map((res:RequestResponse) =>{
          return res;
        }),
        catchError((err)=> this.handlerError(err))
      );
    }
    //ObtenerTodo
  traerTodosDiasLibres(): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/diasLibres`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ObtenerTodoAsync
  async traerTodosDiasLibresAsync(): Promise<RequestResponse> {
    try {
      return await this.http.get<RequestResponse>(`${environment.API}/rrhh/diasLibres`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener las horas extras'} as RequestResponse
    }
  }
    //TraerPorId
    traerDiaLibreId(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/diasLibres/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRutMesActual
  traerPorTrabajadorActualDiasLibres(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/diasLibres/idTrabajador/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRut
  traerTodasTrabajador(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/diasLibres/horasTrabajador/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRutAsync
  async traerTodasTrabajadorAsync(id: number): Promise<RequestResponse> {
    try {
      return await this.http.get<RequestResponse>(`${environment.API}/rrhh/diasLibres/horasTrabajador/${id}`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener las horas extras.'} as RequestResponse
    }
  }

    //Update_horaExtra
    actualizarDiaLibre(diasLibres: any): Observable<RequestResponse> {
      return this.http
          .put<RequestResponse>(`${environment.API}/rrhh/diasLibres/actualizar/ ${diasLibres.id}`, diasLibres)
          .pipe(
              map((res: RequestResponse) => {
                  return res;
              }),
              catchError((err) => this.handlerError(err))
          )
  }

    private handlerError(err: any): Observable<never> {
        let errorMessage = ""
        if (err) {
            errorMessage = `Error: ${err.error.msg}`
        }
        this.alert.error_small(err.error.msg)
        return throwError(errorMessage)
    }
}
